module.exports = __webpack_public_path__ + "img/CLOSED.ed4e243d.svg";